export const fi = {
  deliveryPickUpTime: "Noutoaika",
  deliveryTargetTime: "Toimitusaika",
  from: "Mistä",
  to: "Mihin",
  status: "Tila",
  actions: "Tominnot",
  auth: {
    alreadyHaveAccount: "Onko sinulla jo tili?",
    email: "Sähköposti",
    password: "Salasana",
    login: "Kirjaudu sisään",
    signup: "Rekisteröidy",
    logout: "Kirjaudu ulos",
    loginDescription: "Tervetuloa takaisin! Kirjaudu sisään jatkaaksesi.",
    loggingIn: "Kirjaudutaan sisään...",
    continueWithGoogle: "Jatka Google-tilillä",
    or: "TAI",
    noAccount: "Ei vielä tiliä?",
    signUp: "Rekisteröidy",
    backToHome: "Takaisin etusivulle",
    createAccount: "Luo tili",
    createAccountDesc: "Liity ja ala lähettämään paketteja",
    creatingAccount: "Luodaan tiliä...",
    organizationInvite: "Organisaatiokutsu",
    inviteMessage: "Sinut on kutsuttu liittymään:",
    loadingOrganizationInfo: "Ladataan organisaation tietoja...",
    accountCreationFailed: "Tilin luonti epäonnistui.",
    passwordHelper: "Vähintään 6 merkkiä",
    confirmPassword: "Vahvista salasana",
    acceptTerms: "Hyväksyn ",
    termsOfService: "käyttöehdot",
    error: {
      passwordTooShort: "Salasanan tulee olla vähintään 6 merkkiä pitkä",
      loginFailed: "Kirjautuminen epäonnistui",
      unknownError: "Odottamaton virhe. Yritä uudelleen.",
      googleLoginFailed: "Google-kirjautuminen epäonnistui",
      organizationInfoNotFound: "Organisaatiotietoja ei löytynyt",
      organizationInfoFetchFailed: "Organisaatiotietojen hakeminen epäonnistui",
      emailRequired: "Sähköposti on vaadittu",
      invalidEmail: "Sähköposti ei kelpaa",
      passwordMismatch: "Salasanat eivät täsmää",
      acceptTerms: "Sinun tulee hyväksyä käyttöehdot",
      accountCreationFailed: "Tilin luonti epäonnistui",
    }
  },
  header: {
    appName: "PH",
    activity: "Toimitukset",
    sendPackage: "Lähetä",
    deliverPackage: "Kuljeta",
    profile: "Profiili",
    carry: 'Kuljeta',
    organisation: 'Organisaatio',
    payments: "Maksut",
    myDeliveries: "Omat kuljetukset",
    settings: "Asetukset",
    logout: "Kirjaudu ulos",
    login: "Kirjaudu sisään",
    signup: "Rekisteröidy",
    info: "Info",
  },
  delivery: {
    courier: "Kuriiri",
    segments: "segmenttiä",
    routeSteps: "Kuljetusvaiheet",
    changeBusOption: "Vaihda bussivaihtoehtoa",
    busStep: "Bussisegmentti",
    waitStep: "Bussinvaihto",
    carStep: "Autosegmentti",
    busRoute: "Bussireitti",
    car: "Auto",
    carDesc: "Suora kuriiritoimitus autolla",
    publicTransport: "Julkinen liikenne",
    publicTransportDesc: "Toimitus bussilla tai junalla",
    selectAddressesToSeeOptions: "Valitse osoitteet nähdäksesi toimitusvaihtoehdot",
    noOptionsAvailable: "Tälle reitille ei ole toimitusvaihtoehtoja",
    selectBasicOption: "Valitse perustoimituksen vaihtoehto",
    selectFastOption: "Valitse nopean toimituksen vaihtoehto",
    notSet: "Ei asetettu",

    // bussi
    updateBusSchedule: "Päivitä bussin aikataulu",
    // pakkaus
    needPackaging: "Tarvitsetko pakkausmateriaalia?",
    packagingUpsell: "Tilaa pakkausmateriaalit tuotteillesi edullisesti.",

    // Billing Section
    billingInfo: "Laskutustiedot",

    paymentMethod: "Maksutapa",
    invoice: "Lasku",
    invoiceDescription: "Maksa myöhemmin laskulla",
    card: "Kortti",
    cardDescription: "Maksa heti kortilla",
    yNumber: "Y-tunnus",
    yNumberHelper: "Valinnainen - Suomalainen Y-tunnus",
    companyName: "Yrityksen nimi",
    companyNamePlaceholder: "Yritys Oy",
    companyNameHelper: "Valinnainen",
    paymentReference: "Maksuviite",
    paymentReferencePlaceholder: "Viitenumero tai projektikoodi",
    paymentReferenceHelper: "Valinnainen - sisäiseen seurantaan",
    billingDepartment: "Kustannusyksikkö",
    billingDepartmentPlaceholder: "Osaston nimi tai kustannuspaikka",
    billingDepartmentHelper: "Valinnainen",
    cardPaymentNote:
      "Maksu käsitellään toimituksen lähettämisen jälkeen. Sinut ohjataan maksusivulle.",

    payNow: "Maksa nyt",
    payForDelivery: "Maksa toimitus",
    paymentRequired: "Maksu vaaditaan",
    paymentSuccessful: "Maksu onnistui!",
    paymentFailed: "Maksu epäonnistui. Yritä uudelleen.",
    noOptionsSelected: "Ei valittuja erikoisvaihtoehtoja",

    selectOptions: "Valitse lisäasetukset",
    billingAndOptions: "Laskutus ja lisäasetukset",
    "eco-bus": "Bussipaketti",
    "eco-regular": "Peruspaketti",

    timing: "Nouto -ja toimitusaika",
    locations: "Nouto -ja toimituspaikka",
    people: "Lähettäjä ja vastaanottaja",
    returnParcel: "Paluulinkki",
    prePaid: "Ennakkomaksu",
    packageInfo: "Paketin tiedot",
    billing: "Laskutus",
    total: "Yhteensä",
    sender: "Lähettäjä",
    recipient: "Vastaanottaja",
    delivery: "Toimitus",
    reviewDelivery: "Tarkista lähetys",
    reviewDescription: "Katso että lähetystiedot ovat oikein",
    confirmAndPay: "Vahvista ja lähetä",
    packageCategory: "Kokoluokka",
    selectItems: "Valitse tuotteet",
    selectPackageItems: "Lähetyksen määrittely",
    items: "tuotetta",
    kg: "kg",
    route: "Reitti",
    origin: "Lähtöpaikka",
    destination: "Määränpää",
    originHelp: "Pakettisi noutopaikka",
    labelsInfo:
      "Tulosta lähetystarrat ja kiinnitä ne paketteihin ennen noutoa.",
    selectProductsForLabels: "Valitse paketti, jolle haluat tulostaa tarrat",
    printLabelsSubtitle: "Valitse paketti ja tulosta osoitetarrat",
    printLabels: "Print Labels",
    pickupNow: "Noudettavissa heti",
    pickupDate: "Noutopäivä",
    today: "Tänään",
    tomorrow: "Huomenna",

    pickupTimeModal: {
      title: "Noutoaika",
      time: "Noutoaika",
    },
    // Olemassa olevat käännökset (pidä kaikki olemassa olevat)
    express: "nyt",
    today: "tänään",
    tomorrow: "huomenna",
    standard: "1-5 päivää",
    custom: "mukautettu",
    any: "ei aikatoivetta toimitukselle",
    from: "Lähtöpaikka",
    to: "Määränpää",
    bustransport: "Bussikuljetus",
    noDeliveries: "Ei kuljetuksia vielä",
    printWaybill: "Tulosta rahtikirja",
    resend: "Lähetä uudelleen",
    waybillPrinted: "Rahtikirja ladattu onnistuneesti",

    status: {
      active: "Aktiivinen",
      ongoing: "Kuljettaja löytynyt",
      accepted: "Hyväksytty",
      picked: "Noudettu",
      completed: "Valmis",
      cancelled: "Peruutettu",
    },

    // Sivun otsikko
    sendPackage: "Lähetä",
    deliverPackage: "Kuljeta",


    // Paikka-kentät
    pickup: "Nouto",
    dropoff: "Toimitus",

    // Paketin koko
    selectPackageSize: "Valitse koko",
    size: "Koko",
    small: "Pieni (0–20 kg)",
    medium: "Keskikokoinen (20–30 kg)",
    large: "Suuri (30–90 kg)",
    xl: "Erittäin suuri (90+ kg)",

    // Paino
    weight: "Paino (kg)",

    // Tiedot
    moreDetails: "Lisätiedot",
    detailsTitle: "📋 Lisätietoja",

    // Etäisyys ja kesto
    distance: "Matka (km)",
    duration: "Kesto (min)",
    distanceWithDuration: " km • min",

    // Painikkeet ja toiminnot
    createDelivery: "Jatka",
    createDeliveryWithPrice: "Luo lähetys • {{price}}€",
    create: "Luo",
    creating: "Luodaan...",
    creatingDelivery: "Luodaan...",

    // Arvio
    estimate: "Arvio",
    estimatedPrice: "Arvioitu hinta",

    // Toimitusvaihtoehdot
    deliveryOptions: "Toimitusvaihtoehdot",
    calculatingRates: "Lasketaan hintoja...",
    enterAddressesPrompt:
      "Syötä nouto- ja toimitusosoitteet nähdäksesi vaihtoehdot",

    // ✅ UUSI: Päätoimitustyypit
    express: "Pikatoimitus",
    expressDesc: "Nopein saatavilla oleva toimitus",
    ecoBus: "Bussipaketti",
    fast: "Nopea",
    fastDesc: "Nopea toimituspalvelu",
    eco: "Eko",
    ecoDesc: "Edullisin vaihtoehto - joustava toimitus",

    // ✅ UUSI: Yleiset
    startingFrom: "Alkaen",
    earliestDelivery: "Aikaisin mahdollinen toimitus",

    // Vaihtoehtojen tyypit (olemassa olevat)
    busparcel: "Bussipaketti",
    busparcelDesc: "Bussipaketti - klikkaa valitaksesi",
    custom: "Mukautettu",
    customDesc: "Aseta oma hintasi",
    customPriceLabel: "Mukautettu hinta (€)",

    "eco-bus": "Bussipaketti",

    // ✅ UUSI: Eco-valikko
    selectEcoOption: "Valitse kuljetustapa",
    busTransport: "Bussikuljetus",
    busTransportDesc: "Toimitus julkisen liikenteen verkostossa",
    regular: "Normaali",
    regularDesc: "Tavallinen pakettitoimitus",
    bid: "Tarjous",
    bidDesc: "Aseta oma hintasi - ei taattu",

    // ✅ UUSI: Normaalitoimitus
    regularOptions: "Normaalitoimitus Vaihtoehdot",
    pickupLocation: "Nouto",
    deliveryLocation: "Toimitus",
    parcelCenter: "Pakettipiste",
    homePickup: "Nouto kotoa",
    homeDelivery: "Kotiinkuljetus",
    free: "Ilmainen",
    totalPrice: "Kokonaishinta",

    // ✅ UUSI: Tarjous
    bidTitle: "Aseta tarjouksesi",
    bidWarning:
      "Huomio: suhteuta tarjouksesi toimitusaikatauluun ja etäisyyteen. Liian alhainen tarjous voi johtaa siihen, ettei toimitukselle löydy kuljettajaa.",
    yourPrice: "Hintasi",
    priceLabel: "Hinta (€)",
    pickupTime: "Noudettavissa aikaisintaan",
    latestPickupTime: "Noudettava viimeistään",
    latestPickUpHelp: "Valinnainen: määritä viimeisin noutoaika",
    targetTime: "Toimitettu viimeistään",
    earliestTargetTime: "Toimitettavissa aikaisintaan",
    earliestPickupTime: "Noudettavissa aikaisintaan",
    latestPickup: "Noudettava viimeistään",
    latestTargetTime: "Toimitettava viimeistään",
    hideTimeWindow: "Peru määritys",
    setTimeWindow: "Tarkenna aika-ikkunaa",
    date: "Päivämäärä",
    time: "Nouto -ja toimitusaika",

    // Erikoisvaihtoehdot
    specialOptions: "Erikoisvaihtoehdot",
    returnParcels: "Paketinpalautus",
    returnMethod: "Palautustapa",
    returnByBus: "Bussi",
    returnByPost: "Posti",
    returnParcelsDesc: "Lähetys palautuu lähettäjälle toimituksen jälkeen",
    temperatureControl: "Lämpötilan hallinta",
    temperatureControlDesc: "Vaatii lämpötilaseurannan",
    canBeLeftAtDoor: "Kontaktiton toimitus",
    canBeLeftAtDoorDesc: "Paketti voidaan jättää vastaanottajan ovelle",
    requiresPin: "PIN-koodi vaaditaan",
    requiresPinDesc: "Vastaanottajan on annettava PIN-koodi toimituksen vastaanottamiseksi",
    requiresSignature: "Allekirjoitus vaaditaan",
    requiresSignatureDesc: "Vastaanottajan on allekirjoitettava toimitus",

    // Omat kuljetukset
    sendNew: "Luo lähetys",
    myDeliveries: "Omat lähetykset",
    resendNotification:
      "Kuljetuksen tiedot ladattu. Päivitä ja luo uusi kuljetus.",

    // Nouto- ja toimitusosiot
    pickupDetails: "Noutotiedot",
    deliveryDetails: "Toimitustiedot",
    addressDetails: "Osoitetiedot",
    optional: "(Valinnainen)",
    senderInformation: "Lähettäjän tiedot",
    recipientInformation: "Vastaanottajan tiedot",
    notSelected: "Ei valittu",

    // Aika
    timeWindow: "Aika",
    target: "Tavoiteaika",
    timeWindowPriceNote: "Aikavälin määrittäminen lisää 4€ + ALV",

    // ALV
    vat: "+ alv",

    // Lähettäjä/Vastaanottaja
    senderName: "Lähettäjän nimi",
    senderPhone: "Lähettäjän puhelinnumero",
    senderEmail: "Lähettäjän sähköpostiosoite",
    recipientName: "Vastaanottajan nimi",
    recipientPhone: "Vastaanottajan puhelinnumero",
    recipientEmail: "Vastaanottajan sähköpostiosoite",


    editDetailsDescription: "Muokkaa tietoja",
    selected: "Valittu",
    printSelected: "Tallenna rahtikirjat",
    price: "Hinta",
    company: "Yritys",
    // Lomakekentät
    form: {
      apartmentNumber: "Asunnon numero",
      apartmentPlaceholder: "esim. 12B",
      floor: "Kerros",
      floorPlaceholder: "esim. 3. kerros",
      buildingName: "Rakennuksen nimi",
      buildingPlaceholder: "esim. Rakennus A",
      accessCode: "Pääsykoodi",
      accessCodePlaceholder: "esim. #1234*",
      pickupInstructions: "Nouto-ohjeet",
      pickupInstructionsPlaceholder:
        "Jätä paketti vastaanottoon, soita ovikelloa kahdesti, jne.",
      deliveryInstructions: "Toimitusohjeet",
      deliveryInstructionsPlaceholder: "Jätä ovelle, soita saapuessa, jne.",
      name: "Nimi",
      senderNamePlaceholder: "Lähettäjän nimi",
      recipientNamePlaceholder: "Vastaanottajan nimi",
      phone: "Puhelinnumero",
      phonePlaceholder: "+358 40 123 4567",
      email: "Sähköposti",
      emailPlaceholder: "esimerkki@email.com",
    },

    // Virheilmoitukset
    errors: {
      selectAddresses: "Valitse nouto- ja toimitusosoitteet.",
      selectOption: "Valitse toimitusvaihtoehto.",
      createFailed: "Kuljetuksen luonti epäonnistui.",
      waybillPrintFailed: "Rahtikirjan tulostus epäonnistui.",
    },

    // Onnistumisviestit
    success: {
      created: "Lähetys luotu onnistuneesti!",
    },
    // Kokoluokat
    small: "Pieni paketti",
    medium: "Keskikokoinen",
    large: "Suuri",
    extraLarge: "Erittäin suuri",

    // Tekniset tiedot
    specifications: "Tekniset tiedot",

    maxDimensions: "Maksimimitat",

    // Tuotteet
    items: "Tuotteet",
    item: "Tuote",
    addItem: "Lisää tuote",

    // Mitat
    length: "Pituus (cm)",
    width: "Leveys (cm)",
    height: "Korkeus (cm)",

    // Kokokuvaukset (PACKAGE_SIZES-konfiguraatioon)
    sizeDescriptions: {
      small: {
        example: "Helppo kantaa kädessä",
        description: "Kirjeet, asiakirjat, pienet paketit",
      },
      medium: {
        example: "Mahtuu auton tavaratilaan",
        description: "Keskikokoiset laatikot, urheiluvälineet",
      },
      large: {
        example: "Mahtuu pakettiautoon",
        description: "Suuret laatikot, huonekalut",
      },
      extraLarge: {
        example: "Mahtuu kuorma-autoon",
        description: "Kodinkoneet, suuret huonekalut",
      },
    },
    busTransportModal: {
      // Time
      timePickerHint: "Voit hakea itsellesi sopivan lähtöajan.",
      waitTime: "Odotusaika bussiasemalla",
      title: "Bussipaketti",
      departureTime: "Lähtöaika",
      deliveryOptions: "Toimitusvalinnat",
      includeFirstMile: "Nouto kotoa bussipysäkille",
      includeLastMile: "Toimitus bussipysäkiltä vastaanottajalle",

      // Warnings
      bothSelfService:
        "Sinun tulee viedä paketti lähtöasemalle ja vastaanottajan tulee noutaa se saapumisasemalta.",
      firstMileSelfService: "Sinun tulee viedä paketti lähtöasemalle itse.",
      lastMileSelfService:
        "Vastaanottajan tulee noutaa paketti saapumisasemalta.",

      // Step titles
      selfService: "Itse",
      selfTransport: "Oma kuljetus",
      carTransport: "Kuljetus autolla",
      busTrip: "Bussimatka",
      busSegment: "Bussi",
      carSegment: "Auto",

      // Route info
      route: "Reitti",
      from: "Lähtöpaikka",
      to: "Määränpää",
      distance: "Etäisyys",
      duration: "Kesto",
      steps: "vaihetta",
      busChange: "Bussinvaihto",
      busTransport: "Bussikuljetus",
      availableOptions: "Saatavilla olevat vaihtoehdot",
      noOptions: "Ei saatavilla olevia bussivaihtoehtoja tälle reitille.",

      // Summary
      price: "Hinta",
      routeSteps: "Reitin vaiheet",
      priceBreakdown: "Hinnan erittely",
      departure: "Lähtö",
      arrival: "Saapuminen",
      specifications: "Tiedot",

      // Actions
      select: "Valitse bussipaketti",
      selectTime: "Valitse aika",

      // Errors
      fetchError: "Ei voitu hakea bussiyhteyksiä",
      generalError: "Virhe haettaessa bussivaihtoehtoja",

      //busses
      showRoute: "Näytä reitti",
      hideRoute: "Piilota reitti",
      customRoute: "Muokkaa reittiä",
      editable: "Muokattavissa",
      invalidRoute: "Reitti ei ole kelvollinen",
      addStepAtStart: "Lisää vaihe alkuun",
      addStepAfter: "Lisää vaihe",
      editRoute: "Muokkaa reittiä",
      addStep: "Lisää vaihe",
      editStep: "Muokkaa vaihetta",
      editBusChange: "Muokkaa bussinvaihtoa",
      waitTimeMinutes: "Odotusaika (min)",
      routeNumber: "Linjanumero",
      company: "Yhtiö",
      firstMile: "Nouto",
      lastMile: "Toimitus",
      firstMileDesc: "Kuljetus kotoa bussiasemalle",
      busSegmentDesc: "Bussimatka kahden aseman välillä",
      busChangeDesc: "Odotusaika asemalla",
      lastMileDesc: "Kuljetus bussiasemalta vastaanottajalle",
      noAvailableSteps: "Ei lisättäviä vaiheita",
    },
  },
  // Add to fi.js

  payment: {
    completePayment: "Suorita maksu",
    amountToPay: "Maksettava summa",
    enterPaymentDetails: "Valitse maksutapa ja syötä maksutiedot",
    enterCardDetails: "Valitse maksutapa",
    choosePaymentMethod: "Valitse maksutapa",
    cardTitle: "Kortti",
    cardDescription: "Maksukortti (Visa, MobilePay, Apple Pay, Google Pay)",
    cryptoTitle: "Kryptovaluutta",
    cryptoMethodDescription: "Kryptovaluutta(esim. Bitcoin, Ethereum)",
    cryptoDescription: "Siirryt NOWPayments-palveluun valitsemaan kryptovaluutan ja suorittamaan maksun.",
    continueToCryptoPayment: "Jatka kryptomaksuun",
    reopenCryptoPayment: "Avaa maksusivu uudelleen",
    cryptoWaiting: "Odotetaan maksun suorittamista…",
    cryptoConfirming: "Odotetaan lohkoketjuvahvistusta…",
    cryptoConfirmed: "Maksu vahvistettu!",
    cryptoExpired: "Maksu on vanhentunut. Aloita uudelleen.",
    cryptoFailed: "Maksu epäonnistui. Yritä uudelleen.",
    payAmount: "Maksa {{amount}} €",
    initializationFailed: "Maksun alustus epäonnistui",
    processingPayment: "Käsitellään maksua...",
  },
  terms: {
    title: "Myyntiehdot",
    lastUpdated: "Päivitetty viimeksi",
    footer: {
      rights: "Kaikki oikeudet pidätetään.",
      payment: "Maksu",
      withdrawal: "Peruutusoikeus",
      returns: "Palautukset",
      complaints: "Valitukset",
    },
  },
  // Add to fi.js in the delivery section:

  processing: "Käsitellään...",

  filters: {
    all: "Kaikki",
    location: "Sijainti",
    category: "Kategoria",
    subcategory: "Alakategoria",
    sort: "Järjestä",
    price: "Hinta",
  },
  common: {
    apply: "Valmis",
    reset: "Peruuta",
    done: "Valmis",
    total: "Yhteensä",
    save: "Tallenna",
    cancel: "Peruuta",
    close: "Sulje",
    confirm: "Valitse",
    back: "Takaisin",
    next: "Seuraava",
    submit: "Jatka",
    loading: "Ladataan...",
    error: "Virhe",
    success: "Onnistui",
  },
  // Add these to your existing fi.json translation file

  user: {
    title: "Oma Tili",
    subtitle:
      "Hallitse henkilökohtaisia tietojasi, laskutusta ja organisaatioasetuksia",
    loading: "Ladataan tiliä...",
    tabs: {
      profile: "Profiili",
      billing: "Laskutus",
      organization: "Organisaatio",
    },
  },
  profile: {
    title: "Oma Profiili",
    subtitle: "Hallitse henkilökohtaisia tietojasi ja tiliasetuksiasi",
    loading: "Ladataan profiilia...",
    editButton: "Muokkaa Profiilia",
    saveButton: "Tallenna Muutokset",
    cancelButton: "Peruuta",
    updateSuccess: "Profiili päivitetty onnistuneesti",
    updateError: "Profiilin päivitys epäonnistui. Ole hyvä ja yritä uudelleen.",

    fields: {
      firstName: "Etunimi",
      lastName: "Sukunimi",
      email: "Sähköpostiosoite",
      phone: "Puhelinnumero",
      phonePlaceholder: "+358 40 123 4567",
      mode: "Käyttäjätila",
      optional: "Valinnainen",
    },

    mode: {
      none: "Ei valittu",
      sender: "Lähettäjä",
      courier: "Kuriiri",
    },

    validation: {
      firstNameRequired: "Etunimi on pakollinen",
      lastNameRequired: "Sukunimi on pakollinen",
      emailRequired: "Sähköposti on pakollinen",
      invalidEmail: "Anna kelvollinen sähköpostiosoite",
      invalidPhone: "Anna kelvollinen puhelinnumero",
    },

    accountInfo: {
      title: "Tilin Tiedot",
      userId: "Käyttäjätunnus",
      postalCode: "Postinumero",
      notSet: "Ei asetettu",
      roles: "Roolit",
    },
  },
  billing: {
    title: "Laskutustiedot",
    subtitle: "Hallitse yrityksen tietoja laskutusta varten",
    editButton: "Muokkaa laskutustietoja",
    saveButton: "Tallenna muutokset",
    cancelButton: "Peruuta",
    updateSuccess: "Laskutustiedot päivitetty onnistuneesti",
    updateError: "Laskutustietojen päivitys epäonnistui. Yritä uudelleen.",

    billingInfo: {
      title: "Laskutustiedot",
    },

    paymentInfo: {
      title: "Maksutiedot",
      subtitle: "Tiedot toimitusten palkkioiden vastaanottamiseen",
    },

    fields: {
      yNumber: "Y-tunnus",
      companyName: "Yrityksen nimi",
      billingMethod: "Laskutustapa",
      billingFrequency: "Laskutusväli",
      billingFrequencyHelp: "Kiinteä laskutusjakso",
      paymentYNumber: "Palkkionsaajan Y-tunnus",
      paymentCompanyName: "Yrityksen nimi",
      iban: "IBAN",
    },

    billingMethod: {
      invoice: "Lasku",
      card: "Kortti",
    },

    validation: {
      yNumberRequired: "Y-tunnus vaaditaan",
      companyNameRequired: "Yrityksen nimi vaaditaan",
      paymentYNumberRequired: "Maksun Y-tunnus vaaditaan",
      paymentCompanyNameRequired: "Maksun yrityksen nimi vaaditaan",
      ibanRequired: "IBAN vaaditaan",
      invalidIban: "Virheellinen IBAN-muoto",
    },

    summary: {
      title: "Laskutuksen yhteenveto",
      billingEntity: "Laskutettava yksikkö",
      billingMethod: "Laskutustapa",
      paymentEntity: "Maksun vastaanottaja",
      billingFrequency: "Laskutusväli",
      every7Days: "7 päivän välein",
    },
  },


  organization: {
    tabs: {
      info: "Tiedot",
      deliveries: "Toimitukset"
    },
    title: "Organisaatio",
    subtitle: "Hallitse organisaatiotasi ja tiimin jäseniä",
    editButton: "Muokkaa Organisaatiota",
    createButton: "Luo Organisaatio",
    saveButton: "Tallenna Muutokset",
    createAndSaveButton: "Luo organisaatio",
    cancelButton: "Peruuta",
    updateSuccess: "Organisaatio päivitetty onnistuneesti",
    updateError: "Organisaation päivitys epäonnistui. Ole hyvä ja yritä uudelleen.",

    noOrganization: "Ei organisaatiota",
    createPrompt: "Luo organisaatio hallitaksesi jäseniä",
    memberView: "Jäsen",
    readOnlyNotice: "Vain organisaation omistaja voi muokata näitä tietoja",
    inviteLinkCopied: "Kutsulinkki kopioitu leikepöydälle",
    copyFailed: "Kutsulinkin kopiointi epäonnistui",
    memberRemoved: "Jäsen poistettu onnistuneesti",
    removeMemberError: "Jäsenen poistaminen epäonnistui",

    member: "jäsen",
    members: "jäsenet",

    fields: {
      name: "Organisaation nimi",
      organizationName: "Organisaation Nimi",
      organizationNamePlaceholder: "Organisaatiosi",
      description: "Kuvaus",
      descriptionPlaceholder: "Kuvaile, mitä organisaatiosi tekee...",
      email: "Sähköposti",
      phone: "Puhelin",
      postalCode: "Postinumero",
      locationPostalCode: "Sijainnin postinumero",
      locationAddress: "Osoite",
      address: "Osoite",
      addressPlaceholder: "Katuosoite",
      optional: "Valinnainen",
    },

    location: {
      title: "Sijainti",
      subtitle: "Organisaation valinnaiset sijaintitiedot",
    },

    validation: {
      nameRequired: "Organisaation nimi on pakollinen",
    },

    roles: {
      owner: "Omistaja",
      admin: "Ylläpitäjä",
      member: "Jäsen",
    },

    invite: {
      title: "Kutsu jäseniä",
      description: "Jaa tämä linkki kutsuaksesi käyttäjiä organisaatioosi",
      copy: "Kopioi kutsulinkki",
      copied: "Kopioitu!",
    },

    members: {
      title: "Jäsenet",
      description: "Hallitse organisaation jäseniä",
      unnamed: "Nimetön jäsen",
      you: "Sinä",
      remove: "Poista jäsen",
      copyUid: "Kopioi UID",
      uidCopied: "UID kopioitu leikepöydälle",
      addButton: "Lisää Jäsen",
      table: {
        name: "Nimi",
        email: "Sähköposti",
        phone: "Puhelin",
        actions: "Toiminnot",
      },
      removeDialog: {
        title: "Poista jäsen",
        description: "Haluatko varmasti poistaa käyttäjän {{name}} organisaatiosta?",
        confirm: "Poista",
        cancel: "Peruuta",
      },
    },

    addMember: {
      title: "Lisää olemassa oleva käyttäjä",
      description: "Lisää käyttäjä, jolla on jo tili, syöttämällä hänen käyttäjätunnuksensa (UID)",
      uidPlaceholder: "Syötä käyttäjän UID...",
      helperText: "Löydät käyttäjän UID:n hänen profiilistaan tai tiliasetuksista",
      button: "Lisää jäsen",
      uidRequired: "Käyttäjätunnus on pakollinen",
      alreadyMember: "Käyttäjä on jo organisaation jäsen",
      success: "Jäsen lisätty onnistuneesti",
      error: "Jäsenen lisääminen epäonnistui. Tarkista UID ja yritä uudelleen.",
    },

    deleteDialog: {
      title: "Poista tiimin jäsen",
      description: "Haluatko varmasti poistaa käyttäjän {{name}} organisaatiosta?",
      cancel: "Peruuta",
      confirm: "Poista",
    },

    info: {
      title: "Organisaation tiedot",
      name: "Nimi",
      description: "Kuvaus",
      members: "Jäsenet",
      location: "Sijainti",
    },

    deliveries: {
      title: "Organisaation Toimitukset",
      subtitle: "Tarkastele ja hallitse kaikkia organisaatiosi suoritettuja toimituksia",
      ownerOnly: "Vain organisaation omistajat voivat tarkastella toimituksia",
      membersOnly: "Vain organisaation jäsenet voivat tarkastella toimituksia",
      loadError: "Toimitusten lataaminen epäonnistui",
      noDeliveries: "Ei vielä toimituksia",
      noResults: "Yksikään toimitus ei vastaa hakuasi",
      search: "Hae tunnuksella, lähettäjällä, kuriirilla tai sijainnilla...",
      sortBy: "Järjestä",
      order: "Järjestys",
      export: "Vie CSV-tiedostoon",
      rowsPerPage: "Rivejä per sivu",
      stats: {
        total: "Toimituksia Yhteensä",
        revenue: "Kokonaistulot",
        couriers: "Yksilöllisiä Kuriireita",
      },
      sortOptions: {
        date: "Päivämäärä",
        price: "Hinta",
        sender: "Lähettäjä",
        courier: "Kuriiri",
      },
      orderOptions: {
        asc: "Nouseva",
        desc: "Laskeva",
      },
      table: {
        id: "Toimitustunnus",
        date: "Suoritettu",
        sender: "Lähettäjä",
        courier: "Kuriiri",
        route: "Reitti",
        price: "Hinta",
        reward: "Palkkio",
      },
    },
  },
  drive: {
    transportModal: {
      title: "Valitse kuljetustapa",
      options: {
        all: "Kaikki",
        wait: "Bussinvaihto",
        express: "Henkilöauto",
        van: "Pakettiauto",
      },
    },
    locationModal: {
      title: "Päivitä sijainti",
      description: "Kuljetuksia suodatetaan sijaintisi perusteella.",
      label: "Kaupunki tai osoite",
      placeholder: "esim. Helsinki",
      currentLocation: "Sijaintisi",
      locating: "Haetaan sijaintia…",
      useCurrentLocation: "Käytä nykyistä sijaintia",
    },
    reportProblem: {
      title: "Ilmoita ongelma",
      description: "Valitse ongelman tyyppi ja kerro halutessasi lisätietoja.",
      detailsLabel: "Lisätietoja (valinnainen)",
      detailsPlaceholder: "Kerro tarkemmin mitä tapahtui…",
      revertLabel: "Peru kuljetus ja vapauta muille",
      revertDescription: "Käytä jos et voi suorittaa kuljetusta loppuun",
      revertWarning: "Kuljetus palautetaan Saatavilla-tilaan. Perumiseen tulee olla hyvä syy, muulloin voidaan veloittaa peruutusmaksu.",
      urgentHelp: "Kiireellisissä tapauksissa soita +358 50 505 8167",
      submitting: "Lähetetään…",
      submit: "Lähetä ilmoitus",
      revertAndSubmit: "Peru ja lähetä ilmoitus",
      issues: {
        not_found: "En löydä pakettia",
        address_wrong: "Osoite väärin",
        recipient_unreachable: "Vastaanottaja ei tavoitettavissa",
        package_damaged: "Paketti vaurioitunut",
        bus_issue: "Ongelma bussikuljetuksessa",
        other: "Muu",
      },
    },
  },
  "downloadApp": {
  "title": "Pakettihuolto-sovellus",
  "subtitle": "Kuljettajan sovellus Android-puhelimille",
  "download": "Lataa sovellus",
  "preparing": "Valmistellaan latausta…",
  "versionInfo": "Versio {{version}} · Android 8.0 tai uudempi",
  "stepsTitle": "Näin otat sovelluksen käyttöön",
  "unknownSources": "Jos asennus ei käynnisty, salli puhelimen asetuksista asennus tuntemattomista lähteistä sille sovellukselle, josta avasit tiedoston (yleensä Chrome tai Tiedostot).",
  "support": "Ongelmia asennuksessa? Ota yhteyttä tuki@pakettihuolto.fi",
  "error": {
    "urlFailed": "Latauslinkkiä ei saatu haettua. Yritä hetken kuluttua uudelleen."
  },
  "notice": {
    "ios": "Sovellus toimii vain Android-puhelimissa. iPhonella voit käyttää pakettihuolto.fi-sivustoa selaimessa.",
    "desktop": "Avaa tämä sivu Android-puhelimellasi, niin voit asentaa sovelluksen suoraan."
  },
  "steps": {
    "install": {
  "title": "Avaa tiedosto ja paina Asenna",
  "body": "Avaa ladattu APK-tiedosto ilmoituksista tai Tiedostot-sovelluksesta. Kun Android kysyy, haluatko asentaa sovelluksen, paina Asenna."
},
"playProtect": {
  "title": "Salli asennus, jos Play Protect varoittaa",
  "body": "Koska sovellus ei ole Google Playsta, näytölle voi tulla varoitus. Paina \"Lisätietoja\" ja sen jälkeen \"Asenna silti\" jatkaaksesi."
},
    "login": {
      "title": "Kirjaudu sisään",
      "body": "Käytä samoja tunnuksia kuin pakettihuolto.fi-palvelussa."
    },
    "deliveries": {
      "title": "Katso toimitukset",
      "body": "Sinulle osoitetut toimitukset näkyvät Aula-välilehdellä."
    }
  }
}
};
